import { CSSProperties, useCallback, useEffect, useState } from "react";
import { LeftIcon } from "../Icons";
import classes from "./BackToTop.module.css";

interface Props {
	className?: string;
	style?: CSSProperties;
}

const BackToTop = ({ className, style }: Props) => {
	const [show, setShow] = useState(false);

	useEffect(() => {
		const scrollHandler = () => {
			if (window?.scrollY > 100) {
				setShow(true);
			} else {
				setShow(false);
			}
		};

		document.addEventListener("scroll", scrollHandler);

		return () => {
			document.removeEventListener("scroll", scrollHandler);
		};
	}, []);

	const toTopHandler = useCallback(() => {
		window?.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	}, []);

	const classNames = [classes.BackToTop, className];

	if (show) classNames.push(classes.show);

	return (
		<button
			onClick={() => toTopHandler()}
			className={classNames.join(" ")}
			style={style}>
			<LeftIcon className={classes.icon} width={24} height={24} />
		</button>
	);
};

export default BackToTop;
